export default {
  getDeliveryNote: (state) => state.deliveryNote,
};
